import { $api } from "../AxiosInstance";

const headers = {
  "Content-Type": "text/plain",
  Accept: "application/json"
};

export class FileService {
  static async getById(id) {
    return await $api.get("/api/admin/files/id", { params: { id } });
  }

  static async getAll() {
    return await $api.get("/api/admin/files/all");
  }

  static async create({ name, content }) {
    return await $api.post("/api/admin/files/create", { name, content });
  }

  static async update({ name, content }) {
    return await $api.put("/api/admin/files/update", { name, content });
  }

  static async deleteById(id) {
    return await $api.delete("/api/admin/files/deleteById", { params: { id } });
  }

  static async getFrontErrorReportPage(page, size) {
    return await $api.get("/api/admin/front/error/report/list", {
      params: { page, size },
    });
  }

  static async getFrontErrorReportEntity(id) {
    return await $api.get("/api/admin/front/error/report", { params: { id } });
  }
  
  static async generateNewSitemap() {
    return $api.post(`/api/admin/v1/sitemap-generator/v1/generate`);
  }
  
  static async getSitemapByLocale(locale) {
    const { data } = await $api.get(`/api/admin/v1/sitemap-generator/v1/${locale}`);
    return data;
  }
  
  static async updateSitemapByLocale(text, locale) {
    const { data } = await $api.put(`/api/admin/v1/sitemap-generator/v1/${locale}`, text, {
      headers
    });
    
    return data;
  }
  
  static async getRobots() {
    const { data } = await $api.get("/api/admin/v1/robots-generator/v1/robots.txt");
    return data;
  }
  
  static generateNewRobots() {
    return $api.post("/api/admin/v1/robots-generator/v1/generate");
  }
  
  static async updateRobots(text) {
    const { data } = await $api.put("/api/admin/v1/robots-generator/v1/robots.txt", text, {
      headers
    });
    return data;
  }
}
